module.exports = __webpack_public_path__ + "static/testimonial-6-1892082d16b42e93b04d6993aaf0a16a.png";